import { render, staticRenderFns } from "./ExpertFeesTable.vue?vue&type=template&id=30c30739&scoped=true"
import script from "./ExpertFeesTable.vue?vue&type=script&lang=js"
export * from "./ExpertFeesTable.vue?vue&type=script&lang=js"
import style0 from "./ExpertFeesTable.vue?vue&type=style&index=0&id=30c30739&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c30739",
  null
  
)

export default component.exports